module.exports = __webpack_public_path__ + "media/icons/exit-87650695.svg";